import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { ILabelBlockItem } from '@shared/types/common/label.type';
import { some } from 'lodash';

@Component({
  selector: 'xvi-label-block',
  templateUrl: './label-block.component.html',
  styleUrls: ['./label-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XVILabelBlockComponent implements OnInit {
  @Input() public labels: ILabelBlockItem[] = [];

  public constructor() {}

  public ngOnInit() {}

  public showAnyLabel(): boolean {
    return some(this.labels, (label) => label.show);
  }
}
